import React from 'react'
import { FormSelect } from 'atoms/Inputs'

export const selectFormatter = (cellContent, row, rowIndex, formatExtraData) => {
  const inputConfig = {
    rad: '6px',
    width: '100%',
    yxPadding: '9px 12px',
    height: '30px',
  }

  const {
    placeholder = '',
    options,
    field,
    fn,
    allowEdit,
    valField = 'value',
    dispField = 'name'
  } = formatExtraData
  return (
    <FormSelect
      key={rowIndex}
      placeholder={placeholder}
      allowEdit={allowEdit}
      options={typeof options === 'function' ? options(row) : options}
      valField={valField}
      dispField={dispField}
      arrowPos={'calc(100% - 12px)'}
      arrowSize={'16px'}
      mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
      value={row[field]}
      onChangeVal={e => fn(e.target.value, row, field, rowIndex)}
      style={{ backgroundColor: '#fff'}}
      {...inputConfig}
    />
  )
}
